<template>
    <QrWrapper>
        <div class="max-w-xl mx-auto">
            <QrCard :header="trans('header.update-user-information')" header-trans="header.update-user-information">
                <QrForm @submit.prevent="update" class="space-y-4 ">
                    <QrInput v-model="name" :label="trans('input.name')" :errors="validationErrors.name"/>
                    <QrInput v-model="email" :label="trans('input.email')" type="email" :errors="validationErrors.email"/>
                    <QrSelect
                        v-model="country"
                        :label="trans('input.country')"
                        :options="[
                            { text: trans('option.norway'), value: 'norway' },
                            { text: trans('option.sweden'), value: 'sweden' },
                            { text: trans('option.england'), value: 'england' },
                        ]"
                    />

                    <QrInput
                        v-model="password"
                        :label="trans('input.change-password')" trans="input.change-password"
                        type="password"
                        :errors="validationErrors.password"
                    />

                    <QrInput
                        v-if="password"
                        v-model="passwordConfirmation"
                        :label="trans('input.confirm-new-password')"
                        trans="input.confirm-new-password"
                        type="password"
                        :errors="validationErrors.password_confirmation"
                    />

                    <QrButton
                        type="submit"
                        :loading="loading"
                        :recently-failed="recentlyFailed"
                        :recently-succeeded="recentlySucceeded"
                        :text="trans('button.update')" trans="button.update"
                        class="w-full"
                    />
                </QrForm>
            </QrCard>
        </div>
    </QrWrapper>
</template>

<script setup>
import QrInput from "@/components/application-ui/form/QrInput.vue";
import { onMounted, ref } from "vue";
import { trans } from "@/libs/helper.js";
import { useUserStore } from "@/store/user.js";
import { useStatesStore } from "@/store/states.js";
import { storeToRefs } from "pinia";
import QrForm from "@/components/application-ui/content/QrForm.vue";
import QrWrapper from "@/components/application-ui/panels/QrWrapper.vue";
import QrSelect from "@/components/application-ui/form/QrSelect.vue";
import QrButton from "@/components/application-ui/elements/QrButton.vue";
import QrCard from "@/components/application-ui/panels/QrCard.vue";

const userStore = useUserStore();
const satesStore = useStatesStore();

const name = ref(null);
const email = ref(null);
const country = ref(null);
const password = ref(null);
const passwordConfirmation = ref(null);

const { loading, recentlySucceeded, recentlyFailed, validationErrors } = storeToRefs(satesStore);
const { user } = storeToRefs(userStore);

const update = () => {
    userStore.update({
        name: name.value,
        email: email.value,
        country: country.value,
        password: password.value,
        password_confirmation: passwordConfirmation.value,
    });
};

onMounted(() => {
    name.value = user.value.name;
    email.value = user.value.email;
    country.value = user.value.country;
});
</script>
